<template lang="pug">
.home-count-box.box.box-margin(v-cloak)
  .box-header(v-if="title")
    span.title {{ title }}
  .box-body
    .loading(v-if="isBusy")
      b-spinner.spinner
    .counts(v-else)
      span.value {{ count }}
      span.unit(v-if="unit") {{ unit }}
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * ホーム画面、カウントコンポーネント
 */
@Component
export default class HomeCountBox extends Vue {
  /** タイトル */
  @Prop({
    default: () => {
      return "";
    }
  })
  title!: string;

  /** カウント数 */
  @Prop({
    default: () => {
      return "-";
    }
  })
  count!: string | number;

  /** 単位 */
  @Prop({
    default: () => {
      return "";
    }
  })
  unit!: string;

  /** ローディング表示可否 */
  @Prop({
    default: () => {
      return false;
    }
  })
  isBusy!: boolean;

  /**
   * vue lifecycle created
   */
  public created(): void {
    return;
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/pc/_colors.scss";
@import "../../styles/pc/_mixin.scss";

.home-count-box {
  .box-header {
    padding-top: 6px;
    padding-bottom: 7px;

    .title {
      @include bold-font();
    }
  }
  .box-body {
    text-align: right;
    padding: 0;

    .loading {
      padding: 9px;
      .spinner {
        width: 30px;
        height: 30px;
        color: $loading;
      }
    }

    .counts {
      padding: 0 10px 0 0;
      .value {
        @include font(32px);
      }
      .unit {
        @include font();
      }
    }
  }
}
</style>
